import { tsInitVue } from './js-utils'

document.addEventListener('DOMContentLoaded', function () {
  const filterEl = document.querySelector('body.ospe-survey-results div[data-is="SurveyResultsFilter"]')
  if (filterEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const filterControl = await import('./vue-components/ospe/survey-results-filter.vue')
      tsInitVue(filterControl.default, filterEl, {
        docxUrl: filterEl.dataset.docxUrl,
        xlsxUrl: filterEl.dataset.xlsxUrl,
        ncpData: Array.isArray(window.ncpData) ? window.ncpData : [],
      })
    })()
  }
})
